import React, {useState, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {useHistory, useLocation} from 'react-router-dom'
import useInterval from '@use-it/interval'
import {useSelector} from "react-redux";
import {hasIotCookieConsent} from "./use_tracking";
import Cookies from 'js-cookie'
import { uniq, map } from 'lodash'
import {Helmet} from "react-helmet";
import RenderedHtmlContent from "src/shared/virtual_congress/components/rendered_html_content";

export default function GoogleAnalyticsTracking({trackingId, ...props}) {
  const {listen} = useHistory()
  const hostname = useSelector(state => state.hostname)
  const serverSettings = useSelector(state => state.serverSettings || {})
  const startLocation = useLocation()
  const tagOwner = useSelector(state => state.tagOwner)

  const useCookieStore = useSelector(state => state.serverSettings?.tracking_cookie_store)
  const gdprConfirmationRequired = useSelector(state => state.serverSettings?.tracking_gdpr_required || state.gdprConfirmationRequired == true)
  const existingGdprStatus = useSelector(state => useCookieStore ? Cookies?.get("gdprstatus")?.toString() == "true" : state.gdprConfirmation?.tracking_accepted)

  // get ALL Tracking ids, either from props or ServerSettings
  const getTrackingIds = () => {
    let foundTrackingIds = []
    if(serverSettings.tracking_identifiers && serverSettings.tracking_identifiers != "") {
      map(serverSettings.tracking_identifiers.split(","), (identifier) => {
        foundTrackingIds.push(identifier)
      })
    }
    if(Array.isArray(trackingId)) {
      map(trackingId, (identifier) => {
        foundTrackingIds.push(identifier)
      })
    } else {
      if(trackingId && trackingId != "") {
        foundTrackingIds.push(trackingId)
      }
    }

    return uniq(foundTrackingIds)
  }

  const trackingIds = getTrackingIds()

  // useEffect(() => {
  //   console.debug("GoogleAnalyticsTracking", " startLocation", startLocation.pathname, trackingId, window.gtag)
  //   if (!window.gtag) return
  //   if (!trackingId) {
  //     console.log(
  //       'Tracking not enabled, as `trackingId` was not given and there is no `GA_MEASUREMENT_ID`.'
  //     )
  //     return
  //   }
  //   console.debug("GoogleAnalyticsTracking", " Sending google tracking", startLocation.pathname)
  //   if (Array.isArray(trackingId)) {
  //     trackingId.map(trackId => {
  //       window.gtag('config', trackId, {'page_path': startLocation.pathname})
  //     })
  //   } else {
  //     window.gtag('config', trackingId, {'page_path': startLocation.pathname})
  //   }
  // }, [])

  useEffect(() => {
    const unlisten = listen((location) => {
      if (hostname === "flaveiot20" && !hasIotCookieConsent()) {
        console.debug("GoogleAnalyticsTracking", "ignoring tracking to insufficient a1 cookie consent.")
        return
      }
      console.debug("GoogleAnalyticsTracking", " History change", location)
      if (!window.gtag) return
      if (trackingIds.length == 0) {
        console.debug(
          "GoogleAnalyticsTracking", "Tracking not enabled, as `trackingId` was not given and there is no `GA_MEASUREMENT_ID`."
        )
        return
      }

      console.debug("Sending google tracking to", trackingIds, location.pathname)
      trackingIds.map(trackId => {
        window.gtag('config', trackId, {'page_path': location.pathname, page_view: true})
      })

    })

    return unlisten
  }, [trackingIds, listen, hostname])


  useInterval(() => {
    if (hostname === "flaveiot20" && !hasIotCookieConsent()) {
      console.debug("GoogleAnalyticsTracking", "ignoring tracking to insufficient a1 cookie consent.")
      return
    }
    if (!window.gtag) {
      console.log("No window.gtag method defined")
      return
    }
    if (trackingIds.length == 0) {
      console.log(
        "GoogleAnalyticsTracking", "Tracking not enabled, as `trackingId` was not given and there is no `GA_MEASUREMENT_ID`."
      )
      return
    }

    console.log("Sending google analytics gtag heartbeat")
    //trackingIds.map(trackId => { // hier wird die Tracking-ID ja garnicht verwendet?
    window.gtag('event', 'heartbeat')
    //})
  }, 3 * 60 * 1000)

  // console.log("serverSettings.tracking_enabled", serverSettings.tracking_enabled)
  // console.log("serverSettings.existingGdprStatus", existingGdprStatus)

  // console.log(document.getElementsByTagName("head")[0])

  return <>
      {serverSettings.tracking_enabled && existingGdprStatus &&
        <>
          {createPortal(
            <RenderedHtmlContent html={serverSettings.tracking_header_code}/>
            , document.getElementsByTagName("head")[0]
            )}
          <RenderedHtmlContent html={serverSettings.tracking_footer_code}/>
        </>
      }
    </>
}